"use strict";
/** Схемы связей, комментариев и журнала действий. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.activityFilterSchema = exports.updateCommentSchema = exports.createCommentSchema = exports.relationTargetQuerySchema = exports.createRelationSchema = void 0;
const contracts_1 = require("@project-os/contracts");
const zod_1 = require("zod");
const common_1 = require("./common");
// --- Связи ---------------------------------------------------------------
exports.createRelationSchema = zod_1.z.object({
    /** Второй элемент связи. Первый берётся из адреса. */
    toItemId: common_1.uuidSchema,
    relationType: zod_1.z.enum(contracts_1.RELATION_TYPES),
});
/** Поиск элемента для связывания. */
exports.relationTargetQuerySchema = zod_1.z.object({
    search: zod_1.z.string().trim().max(300).optional(),
    limit: zod_1.z.coerce.number().int().min(1).max(50).default(20),
});
// --- Комментарии ---------------------------------------------------------
const commentBodySchema = common_1.markdownSchema
    .refine((value) => value.trim().length > 0, 'Комментарий не может быть пустым')
    .refine((value) => value.length <= 20_000, 'Комментарий слишком длинный');
exports.createCommentSchema = zod_1.z.object({
    bodyMd: commentBodySchema,
});
exports.updateCommentSchema = zod_1.z.object({
    bodyMd: commentBodySchema,
});
// --- Журнал действий -----------------------------------------------------
exports.activityFilterSchema = zod_1.z.object({
    userId: zod_1.z.preprocess((raw) => (raw === '' || raw === null ? undefined : raw), common_1.uuidSchema.optional()),
    action: zod_1.z.preprocess((raw) => {
        if (raw === undefined || raw === null || raw === '')
            return undefined;
        const list = Array.isArray(raw) ? raw : String(raw).split(',');
        return list.map((value) => String(value).trim()).filter(Boolean);
    }, zod_1.z.array(zod_1.z.enum(contracts_1.ACTIVITY_ACTIONS)).optional()),
    entityType: zod_1.z.string().trim().max(80).optional(),
    entityId: zod_1.z.preprocess((raw) => (raw === '' || raw === null ? undefined : raw), common_1.uuidSchema.optional()),
    /** Границы периода включительно, в датах интерфейса. */
    from: zod_1.z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Дата в формате ГГГГ-ММ-ДД')
        .optional(),
    to: zod_1.z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Дата в формате ГГГГ-ММ-ДД')
        .optional(),
    cursor: zod_1.z.string().max(200).optional(),
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(50),
});
//# sourceMappingURL=collaboration.js.map